import Backbone from 'backbone'
// import Logger from 'Logger'
import _ from 'underscore'

import tpl from './emoticonFilter.mustache'

import { priceFilterHandler } from '../../manager/view.handler'

export var EmoticonFilterView = Backbone.View.extend({
  tagName: 'div',
  className: 'poker-mall-decoration__filter',
  template: tpl,
  events: {
    'click .poker-mall-filter>a': priceFilterHandler,
  },
  initialize: function (options) {
    if (_.isFunction(options.resetSelected)) {
      this.resetSelected = options.resetSelected
    }
  },
  render: function () {
    var rendered = this.template.render()
    this.$el.empty().append(rendered)
    return this
  },
})
